import { toMoment, getSeeComponentsValue } from 'api/helpers';
import { sortArray } from 'utils/helpers';
import OrderType from './OrderType';
import he from 'he';

export default class Offering {
	static getNumber = offering =>
		offering.Number ? offering.Number : offering.Name;

	id = 0;
	image_url = null;
	name = '';
	db_item_name = '';
	start_date = null;
	end_date = null;
	quantity = 0;
	list_price = 0;
	promo_price = 0;
	ta = 0;
	net_price = 0;
	est_ship_date = null;
	est_ship_date_for_cart = null;
	invoice_hold_weeks = '';
	displayed_invoice_hold_weeks = '';
	order_type = null;
	is_drop_ship = false;
	is_configurable = false;
	is_pack = false;
	promotion_name = '';
	promotion_end_date = null;
	category_name = '';
	category_end_date = null;
	promotion_id = 0;
	pack_id = 0;
	category_id = 0;
	number = '';
	base_number = '';
	currency_symbol = '';
	country_short_name = '';
	offerings = null;
	total_config_qty_ordered = 0;
	category_promotion_class_id = 0;
	quantity_available = 0;
	promo_no_of_days = null;
	pack_name = null;
	price_list = null;
	item_description = '';
	category_ship_type_id = 0;
	category_ship_type_name = '';

	constructor(offering) {
		this.is_preview = offering.IsPreview;
		this.id = offering.Id;
		this.image_url = offering.ImageUrl;
		this.name = he.decode(offering.Name);
		this.db_item_name = offering.Name;
		this.base_number = offering.BaseNumber;
		this.start_date = toMoment(offering.StartDate);
		this.end_date = toMoment(offering.EndDate);
		this.quantity = offering.Quantity;
		this.list_price = offering.ListPrice;
		this.promo_price = offering.PromoPrice;
		this.ta = offering.TA;
		this.net_price = offering.NetPrice;
		this.est_ship_date = offering.IsPack ? '' : toMoment(offering.EstShipDate);
		this.est_ship_date_for_cart = toMoment(offering.EstShipDateForCart);
		this.invoice_hold_weeks = offering.OrderType.HoldInvoiceWeeks.toString();
		this.displayed_invoice_hold_weeks = getSeeComponentsValue(
			offering.OrderType.HoldInvoiceWeeks.toString(),
			offering.IsPack
		);
		this.order_type = new OrderType(offering.OrderType);
		this.is_drop_ship = offering.IsDropShipAllowed;
		this.is_configurable = offering.IsConfigurable;
		this.is_pack = offering.IsPack;
		this.promotion_name = offering.PromotionName;
		this.promotion_end_date = toMoment(offering.PromotionEndDate);
		this.category_name = offering.CategoryName;
		this.category_end_date = toMoment(offering.CategoryEndDate);
		this.promotion_id = offering.PromotionId;
		this.pack_id = offering.PackId;
		this.category_id = offering.CategoryId;
		this.number = Offering.getNumber(offering);
		this.currency = {
			currency_symbol: offering.CurrencySymbol,
			country_short_name: offering.CountryShortName,
		};
		this.offerings =
			this.is_pack &&
			sortArray(offering.Offerings, 'Name').map(item => ({
				id: item.Id,
				image_url: item.ImageUrl,
				price_list: item.PriceList,
				price: item.Price,
				promo_no_of_days: item.PromoNoOfDays,
				name: he.decode(item.Name),
				db_item_name: item.Name,
				number: item.Number,
				base_number: item.BaseNumber,
				is_configurable: item.IsConfigurable,
				quantity: item.Quantity,
				invoice_hold_weeks: item.OrderType.HoldInvoiceWeeks,
				order_type: new OrderType(item.OrderType),
				item_description: item.ItemDescription,
				net_price: item.NetPrice,
				est_ship_date: toMoment(item.EstShipDate),
				promo_price: item.PromoPrice,
				is_drop_ship_allowed: item.IsDropShipAllowed,
			}));
		this.total_config_qty_ordered = offering.TotalConfigQtyOrdered;
		this.category_promotion_class_id = offering.CategoryPromotionClassId;
		this.quantity_available = offering.QuantityAvailable;
		this.promo_no_of_days = offering.PromoNoOfDays;
		this.pack_name = offering.IsPack ? offering.PackName : null;
		this.price_list = offering.PriceList;
		this.item_description = offering.ItemDescription;
		this.category_ship_type_id = offering.CategoryShipTypeId;
		this.category_ship_type_name = offering.CategoryShipTypeName;
	}
}



// WEBPACK FOOTER //
// ./src/api/models/Offering.js